import { getShortFormat, getLocaleFormat } from 'utils/numbers';
import { getStringAsCurrency } from 'utils/currency';

export default function Currency(params) {
    const otherFields = params.otherFields ?? params.colDef?.cellRendererParams?.otherFields ?? {};
    const locale = params.locale ?? params.colDef?.cellRendererParams?.locale ?? '';
    let { value } = params;
    if (!value && value !== 0) return null;

    //TODO use currencyFromData and currencyFromLocale and depending on that,
    //use the data currency or get the currencyISO from locale in order to get the right symbol

    let finalValue = value;
    const currencySymbol = params.data?.[otherFields?.symbol] ?? '';

    const currencyCell = document.createElement('div');
    currencyCell.classList.add('w5-currency-cell');

    if (!finalValue) value = 0;

    let numericValue = finalValue;
    if (typeof numericValue === 'string') {
        numericValue = parseFloat(String(numericValue).replace(',', '.')) || 0;
    } else {
        numericValue = Number(numericValue);
    }

    const useLongFormat = otherFields.longFormat !== false;
    const digits = otherFields.digits ?? 2;

    if (useLongFormat) {
        finalValue = getLocaleFormat(numericValue, locale, {
            maximumFractionDigits: digits,
            minimumFractionDigits: digits,
            useGrouping: true,
        });
    } else {
        finalValue = getShortFormat(numericValue, locale, otherFields?.digits);
    }

    finalValue = getStringAsCurrency(finalValue, currencySymbol);
    currencyCell.innerText = finalValue;
    return currencyCell;
}
